export default "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <app-custo-realizado-area></app-custo-realizado-area>\n    </div>\n</div>\n"